import { createUseStyles } from 'react-jss'
import { forDesktopDown } from 'src/config/mediaQueries'
import customColors from 'src/config/colorsV2'
import { typography } from '@dentalux/ui-library-core'
import { Theme } from '@mui/material/styles'

const progressBarStyles = {
  position: 'absolute',
  left: 0,
  height: 4,
  [forDesktopDown]: {
    height: 2,
  },
}

export default createUseStyles((theme: Theme) => ({
  root: {
    width: '80%',
    display: 'flex',
    backgroundColor: customColors.background,
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    maxWidth: 812,
    margin: 'auto',
    paddingBottom: 16,
    [forDesktopDown]: {
      display: 'none',
    },
  },
  step: {
    ...typography['Lato Caption Small Bold'],
    color: theme.palette.grey[700],
    zIndex: 2,
    width: 16,
    height: 16,
    background: theme.palette.grey['400'],
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '100%',
    position: 'relative',
    [forDesktopDown]: {
      width: 16,
      height: 16,
    },
  },
  activeStep: {
    background: theme.palette.primary.main,
    color: customColors.white,
  },
  progressBar: {
    ...progressBarStyles,
    background: theme.palette.grey['400'],
    right: 0,
    zIndex: 1,
  },
  activeProgressBar: {
    ...progressBarStyles,
    zIndex: 2,
    background: theme.palette.primary.main,
    transition: '300ms ease width',
  },
  completedStep: {
    svg: {
      zIndex: 100,
      color: 'white',
    },
  },
  stepName: {
    position: 'absolute',
    top: 20,
    whiteSpace: 'nowrap',
    color: theme.palette.grey[600],
    ...typography['Lato Body 2'],
  },
  activeStepName: {
    color: theme.palette.primary.main,
  },
}))
